/**
 * Lịch cá nhân (2026-10-01) — GET /api/enrollment/me/calendar/?from=&to=
 * Gộp bài kiểm tra / thi, buổi học live, phiên bảo vệ khoá luận của người đăng nhập.
 */
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "./client";

export type CalendarEventType = "exam" | "quiz" | "live" | "defense";

export interface CalendarEvent {
  id: string;
  type: CalendarEventType;
  title: string;
  course: { code: string; name: string; slug: string } | null;
  start: string;
  end: string | null;
  /** Trạng thái buổi live/bảo vệ (scheduled/live/ended/canceled); null cho bài kiểm tra. */
  status: string | null;
  /** Đường dẫn FE mở chi tiết. */
  url: string;
}

export interface CalendarResponse {
  from: string;
  to: string;
  events: CalendarEvent[];
}

/** `from`/`to` dạng YYYY-MM-DD (tối đa 120 ngày). */
export function useMyCalendar(from: string, to: string) {
  return useQuery({
    queryKey: ["calendar", "me", from, to],
    queryFn: async () => {
      const resp = await apiClient.get<CalendarResponse>("/enrollment/me/calendar/", {
        params: { from, to },
      });
      return resp.data;
    },
    staleTime: 60_000,
  });
}
